import { useLocation } from 'react-router-dom';

export function useErrorController() {
  const { pathname } = useLocation();

  return { pathname };
}
